module.exports = __webpack_public_path__ + "static/media/chat-wild-dev.c2648d02.png";